import getWeather from './getWeather';

import './getWeather.css';
import './owfont-regular.css';
import './mapbox-gl.css';

export default getWeather;
